import { Box, Typography, useTheme, Paper } from '@mui/material';
import { alpha } from '@mui/material/styles';

export const InfoItem = ({ label, value, severity }) => {
  const theme = useTheme();

  const textColor = severity ? theme.palette[severity].dark : theme.palette.text.primary;

  return (
    <Box
      sx={{
        flex: 1,
        minWidth: 0,
        px: { xs: 1.5, md: 2 },
        py: { xs: 1, md: 1.5 },
      }}
    >
      <Typography
        variant='overline'
        sx={{
          color: textColor,
          fontWeight: theme.typography.fontWeightBold,
          fontSize: '0.875rem',
          mb: 0.5,
        }}
      >
        {label}
      </Typography>

      <Typography
        variant='body1'
        sx={{
          fontWeight: theme.typography.fontWeightRegular,
          color: textColor,
          lineHeight: 1.3,
          fontSize: '0.875rem',
        }}
      >
        {value}
      </Typography>
    </Box>
  );
};

export default function SolicitudInfoCard({ children, severity = 'primary', ...props }) {
  const theme = useTheme();

  return (
    <Paper
      elevation={0}
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', md: 'row' },
        borderLeft: `6px solid ${theme.palette[severity].main}`,
        borderRadius: 1,
        borderTopLeftRadius: 0,
        borderBottomLeftRadius: 0,
        backgroundColor: '#f8f8f8',
        paddingTop: 2,
        paddingBottom: 2,
        ...(severity && {
          backgroundColor: alpha(theme.palette[severity].main, 0.08),
          borderRadius: 1,
        }),
      }}
    >
      {children}
    </Paper>
  );
}
